module.exports = __webpack_public_path__ + "static/CircularPro-BookItalic.9ea73cc4.woff2";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-BookItalic.woff2
// module id = 729
// module chunks = 168707334958949